export default {
  primary: "#008183",
  transition: "all 0.6s ease 0s"
};
